import { render, staticRenderFns } from "./chooseFormworkDrawer.vue?vue&type=template&id=ddeaac66&scoped=true"
import script from "./chooseFormworkDrawer.vue?vue&type=script&lang=js"
export * from "./chooseFormworkDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddeaac66",
  null
  
)

export default component.exports